<script lang="ts" setup>
import { onMounted, onUnmounted, ref, shallowRef } from 'vue'
import { Marker, MarkerOptions } from 'mapbox-gl'
import { useMapBox } from './composables/useMapBox'

const props = defineProps<{
	latitude: number
	longitude: number
}>()

const markerContainer = ref()

const marker = shallowRef<Marker>()

const { map } = useMapBox()

onMounted(() => {
	marker.value = new Marker({ renderless: true, element: markerContainer.value } as MarkerOptions)
		.setLngLat([props.longitude, props.latitude])
		.addTo(map!.value!)
})

onUnmounted(() => marker.value?.remove())
</script>

<template>
	<div ref="markerContainer">
		<slot></slot>
	</div>
</template>
